import { takeEvery, put, call, select } from 'redux-saga/effects'
import {
  ADD_WORKSHIFTS,
  CONFIRM_BILLABLE_HOUR,
  GET_BILLABLE_HOURS,
  GET_SIGNED_LIGHT_ENTREPRENEUS,
  GET_WORKSHIFTS,
  GET_WORKSHIFT_BY_ID,
  PIN_WORKSHIFT,
  REMOVE_WORKSHIFT,
  UPDATE_WORKSHIFT
} from '../../constants/employer'
import { API_SERVER } from '../../constants'
import {
  getCompanyName,
  getUuid
} from '../../selectors/employer/client.selector'
import { getEditWorkshiftId } from '../../selectors/employer/workshifts.selector'
import { apiManualPost } from '../../utils/employer/request'
import {
  addWorkshiftsFailed,
  addWorkshiftsSuccess,
  confirmBillableHourFailed,
  confirmBillableHourSuccess,
  getBillableHours,
  getBillableHoursFailed,
  getBillableHoursSuccess,
  getSignedLESuccess,
  getWorkshiftbyIdSuccess,
  getWorkshiftbyIdfailed,
  getWorkshifts,
  getWorkshiftsFailed,
  getWorkshiftsSuccess,
  pinWorkshiftFailed,
  pinWorkshiftSuccess,
  removeWorkshiftFailed,
  removeWorkshiftSuccess,
  updateWorkshiftFailed,
  updateWorkshiftSuccess
} from '../../actions/employer'
import { updateFormValues } from '../../form'
import { formatFiDateToISO } from '../../utils/DateTimeFormat'

// Get signed light entrepreneurs
function* getSignedLESaga() {
  try {
    const url = `${API_SERVER}/GetSignedLightEntrepreneursDetails`
    const uuid = yield select(getUuid)

    const body = JSON.stringify({
      uuid: uuid
    })
    const result = yield call(apiManualPost, url, body)
    if (result.data) yield put(getSignedLESuccess(JSON.parse(result.data)))
  } catch (error) {}
}

//Load workshifts
function* getWorkshiftsSaga() {
  try {
    const url = `${API_SERVER}/GetOfferWorkShiftDetails`
    const uuid = yield select(getUuid)
    const body = JSON.stringify({
      uuid: uuid
    })
    const result = yield call(apiManualPost, url, body)
    const parsedResult = JSON.parse(result.data)
    yield put(getWorkshiftsSuccess(parsedResult))
  } catch (error) {
    yield put(getWorkshiftsFailed(error))
  }
}

// Load billable hours
function* getBillableHoursSaga() {
  try {
    const url = `${API_SERVER}/GetBilledWorkShiftDetails`
    const uuid = yield select(getUuid)
    const body = JSON.stringify({
      uuid: uuid
    })
    const result = yield call(apiManualPost, url, body)
    const parsedResult = JSON.parse(result.data)
    yield put(getBillableHoursSuccess(parsedResult))
  } catch (error) {
    yield put(getBillableHoursFailed(error))
  }
}

// Add workshifts
function* addWorkShiftsSaga({ formValues, selectedOfferTo }) {
  try {
    const url = `${API_SERVER}/AddWorkShiftDetails`
    const uuid = yield select(getUuid)
    const dateRows = formValues.dateRows
    const dateRowsFormat = dateRows.map((item) => ({
      ...item,
      shiftstartdate: formatFiDateToISO(item.shiftstartdate),
      shiftstarttime: item.shiftstarttime,
      shiftendtime: item.shiftendtime,
      amount: item.amount === '' ? null : item.amount
    }))

    const body = JSON.stringify({
      uuid: uuid,
      offershift: formValues.offer_to.split('-')[0], // Format: email-assignment_job_id => need only email
      location: formValues.location,
      workshiftlastdate: formatFiDateToISO(formValues.approval_deadline),
      taskdescription: formValues.task_description,
      additionalinfo: formValues.additional_infor,
      workshiftitems: dateRowsFormat,
      contractDetails: [
        {
          assignmentAgreementId: selectedOfferTo.agreement_id,
          salaryModel: selectedOfferTo.salary_model
        }
      ]
    })

    const result = yield call(apiManualPost, url, body)
    if (result.data === 'Work shift details are added successfully') {
      yield put(addWorkshiftsSuccess(result.data))
    } else {
      yield put(addWorkshiftsFailed())
    }

    yield put(getWorkshifts())
  } catch (error) {
    yield put(addWorkshiftsFailed(error))
  }
}

// Update workshift
function* updateWorkshiftSaga({ formValues }) {
  try {
    const url = `${API_SERVER}/UpdateWorkShiftDetails`
    const workshift_id = yield select(getEditWorkshiftId)

    const body = JSON.stringify({
      workshiftid: workshift_id,
      workshiftitems: formValues.dateRows.map((item) => ({
        workshiftitemid: item.workshift_itemid,
        shiftstartdate: formatFiDateToISO(item.shiftstartdate),
        shiftstarttime: item.shiftstarttime,
        shiftendtime: item.shiftendtime,
        amount: item.amount === '' ? null : item.amount
      })),
      offershift: formValues.offer_to.split('-')[0],
      location: formValues.location,
      workshiftlastdate: formatFiDateToISO(formValues.approval_deadline),
      taskdescription: formValues.task_description,
      additionalinfo: formValues.additional_infor,
      // workshiftstatus: '',
      // workshiftstatusentrepreneur: ''
      contractDetails: [
        {
          assignmentAgreementId: formValues.agreement_id,
          salaryModel: formValues.salary_model
        }
      ]
    })
    const result = yield call(apiManualPost, url, body)
    if (result.data) {
      yield put(updateWorkshiftSuccess(result.data))
    } else {
      yield put(updateWorkshiftFailed())
    }
    yield put(getWorkshifts())
    yield put(getBillableHours())
  } catch (error) {
    yield put(updateWorkshiftFailed(error))
  }
}

// Get workshift by ID
function* getWorkshiftByIdSaga({ workshiftId }) {
  try {
    const url = `${API_SERVER}/GetEditWorkShiftDetails`
    const body = JSON.stringify({
      workshiftid: workshiftId
    })
    const result = yield call(apiManualPost, url, body)
    const resultParsed = JSON.parse(result.data)

    if (resultParsed) {
      let formData = {}
      formData.offer_to =
        resultParsed[0].offershift_to + '-' + resultParsed[0].agreement_id
      formData.location = resultParsed[0].location
      formData.approval_deadline = new Date(resultParsed[0].workshift_lastdate)
      formData.task_description = resultParsed[0].task_description
      formData.additional_infor = resultParsed[0].additional_info
      formData.workshift_id = resultParsed[0].workshift_id
      formData.salary_model = resultParsed[0].salary_model
      formData.agreement_id = resultParsed[0].agreement_id

      const transformedData = {
        ...formData,
        dateRows: resultParsed.map((item) => ({
          workshift_itemid: item.workshift_itemid,
          shiftstartdate: new Date(item.workshift_date),
          shiftstarttime: item.workshift_start_time,
          shiftendtime: item.workshift_endtime,
          workshift_status: item.workshift_status,
          workshift_status_entrepreneur: item.workshift_status_entrepreneur,
          amount: item.amount === null ? '' : item.amount
        }))
      }
      yield put(getWorkshiftbyIdSuccess(transformedData))
      yield put(updateFormValues('workshift', transformedData))
    } else {
      yield put(getWorkshiftbyIdfailed())
    }
  } catch (error) {
    yield put(getWorkshiftbyIdfailed(error))
  }
}

// Delete workshift by id
function* removeWorkshiftSaga({ workshiftid, workshift_itemid }) {
  try {
    const url = `${API_SERVER}/DeleteWorkShiftDetails`
    const uuid = yield select(getUuid)

    const body = JSON.stringify({
      workshiftid: workshiftid,
      workshiftitems: [{ workshiftitemid: workshift_itemid }],
      uuid: uuid
    })
    const result = yield call(apiManualPost, url, body)
    if (result.data === 'Work shift data deleted successfully') {
      yield put(removeWorkshiftSuccess(result.data))
    } else {
      yield put(removeWorkshiftFailed())
    }
    yield put(getWorkshifts())
    yield put(getBillableHours())
  } catch (error) {
    yield put(removeWorkshiftFailed(error))
  }
}

// Confirm billable hours
function* confirmBillableHourSaga({ values }) {
  try {
    const url = `${API_SERVER}/UpdateWorkShiftDetails`
    const uuid = yield select(getUuid)
    const company_name = yield select(getCompanyName)

    const body = JSON.stringify({
      workshiftid: values.workshift_id,
      uuid: uuid,
      workshiftstatus: values.workshiftstatus,
      // workshiftstatusentrepreneur: '',
      rateentrepreneur: values.rateentrepreneur,
      actualbilledhours: values.actualbilledhours,
      timespent: values.timespent,
      workshiftitems: [{ workshiftitemid: values.workshift_itemid }],
      workShiftRemarks:
        values?.workShiftRemarks !== ''
          ? `${company_name}: ` + values.workShiftRemarks
          : null
    })

    const result = yield call(apiManualPost, url, body)

    if (result.data) {
      yield put(confirmBillableHourSuccess(result.data))
    } else {
      yield put(confirmBillableHourFailed())
    }
    yield put(getWorkshifts())
    yield put(getBillableHours())
  } catch (error) {
    yield put(confirmBillableHourFailed(error))
  }
}

function* pinWorkshiftSaga({ workshift_itemid }) {
  try {
    const url = `${API_SERVER}/AddPinnedWorkshiftDetails`
    // const uuid = yield select(getUuid)
    const body = JSON.stringify({
      // uuid: uuid,
      workshiftItems: [{ workshiftItemId: workshift_itemid }]
    })
    const result = yield call(apiManualPost, url, body)
    if (result.data === 'Pinned workshift details are added successfully') {
      yield put(pinWorkshiftSuccess(result.data))
    } else {
      yield put(pinWorkshiftFailed(result.data))
    }
    yield put(getWorkshifts())
    yield put(getBillableHours())
  } catch (error) {
    yield put(pinWorkshiftFailed(error))
  }
}

export function* watchGetSignedLESaga() {
  yield takeEvery(GET_SIGNED_LIGHT_ENTREPRENEUS, getSignedLESaga)
}
export function* watchGetWorkshiftsSaga() {
  yield takeEvery(GET_WORKSHIFTS, getWorkshiftsSaga)
}
export function* watchGetBillableHoursSaga() {
  yield takeEvery(GET_BILLABLE_HOURS, getBillableHoursSaga)
}
export function* watchAddWorkShiftsSaga() {
  yield takeEvery(ADD_WORKSHIFTS, addWorkShiftsSaga)
}
export function* watchGetWorkshiftByIdSaga() {
  yield takeEvery(GET_WORKSHIFT_BY_ID, getWorkshiftByIdSaga)
}
export function* watchConfirmBillableHourSaga() {
  yield takeEvery(CONFIRM_BILLABLE_HOUR, confirmBillableHourSaga)
}
export function* watchRemoveWorkshiftSaga() {
  yield takeEvery(REMOVE_WORKSHIFT, removeWorkshiftSaga)
}
export function* watchUpdateWorkshiftSaga() {
  yield takeEvery(UPDATE_WORKSHIFT, updateWorkshiftSaga)
}
export function* watchPinWorkshiftSaga() {
  yield takeEvery(PIN_WORKSHIFT, pinWorkshiftSaga)
}
